import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { ArrowSyncRegular } from "@fluentui/react-icons";

import { useLayoutStore } from "../../../store/layout.store.js";

export const OutdatedOfficeModal = () => {
  const { hideModal } = useLayoutStore();
  const handleReloadOffice = () => {
    hideModal();
    window.location.reload();
  };

  return (
    <Dialog modalType="alert" open={true}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle className="flex items-center gap-2">
            <ArrowSyncRegular className="size-6" />
            This office is outdated
          </DialogTitle>
          <DialogContent>
            <p>
              A newer version of this office is available. Some of your
              colleagues may already be using it. Please reload the office to
              get the latest updates and ensure the best experience.
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={hideModal} type="button">
              Not now
            </Button>
            <Button
              appearance="primary"
              onClick={handleReloadOffice}
              type="button"
            >
              Reload office
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
